import { Suspense } from 'react';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { Skeleton } from '@sara/ui/components/skeleton';
import { BrandingLogoContainerContent } from './BrandingLogoContainerContent';

interface BrandingLogoContainerProps {
  orgId: string;
}

function BrandingLogoSkeleton() {
  return (
    <section className="overflow-hidden rounded-xl border border-border bg-card">
      <div className="flex items-start justify-between gap-4 border-b border-border px-5 py-4 sm:px-6 sm:py-5">
        <div className="space-y-2">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-4 w-72 max-w-full" />
        </div>
        <Skeleton className="h-5 w-9 rounded-full" />
      </div>
      <div className="flex flex-col gap-4 p-5 sm:flex-row sm:p-6">
        <Skeleton className="h-28 w-full rounded-lg sm:w-44" />
        <Skeleton className="h-28 flex-1 rounded-lg" />
      </div>
    </section>
  );
}

export function BrandingLogoContainer({ orgId }: BrandingLogoContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<BrandingLogoSkeleton />}>
        <BrandingLogoContainerContent orgId={orgId} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
